document.addEventListener('DOMContentLoaded', function () {
    const qtyInputs = document.querySelectorAll('input.qty');
    qtyInputs.forEach(function (input) {
        input.addEventListener('change', function () {
            // Znajdź przycisk
            const updateBtn = document.querySelector('button[name="update_cart"]');
            if (updateBtn) {
                updateBtn.removeAttribute('disabled'); // Odblokuj
                updateBtn.click(); // Kliknij programowo
            }
        });
    });
});
jQuery(document).ready(function ($) {
    if ($('.home-2 .sf-kategorie-wrap .sf-kategorie').length) {
        $('.home-2 .sf-kategorie-wrap .sf-kategorie').slick({
            slidesToShow: 7.1,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3.5,
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2.5,
                    }
                }
            ]
        });
    }

    if ($('.home-4 .wp-block-group__inner-container').length) {
        $('.home-4 .wp-block-group__inner-container').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.5,
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1.1,
                    }
                }
            ]
        });
    }

    if ($('.home-9 .wp-block-gallery').length) {
        $('.home-9 .wp-block-gallery').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1.1,
                        arrows: false,
                    }
                }
            ]
        });
    }

    if ($('.sf-category-products ul.products').length) {
        $('.sf-category-products ul.products').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }

    if ($('.related.products').length) {
        $('.related.products ul').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2,
                        arrows: false,
                    }
                }
            ]
        });
    }

    if ($('.archive .sf-kolekcje-slider,.single-product .sf-kolekcje-slider').length) {
        $('.sf-kolekcje-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    const toggleBtn = $('.home-10 a:contains("Rozwiń")');
    const contentBox = $('.home-10 .wp-block-group__inner-container .wp-block-group');

    toggleBtn.on('click', function (e) {
        e.preventDefault();

        contentBox.toggleClass('active');

        if (contentBox.hasClass('active')) {
            contentBox.css('max-height', 'none');
            $(this).text('Zwiń').addClass('active');
        } else {
            contentBox.css('max-height', '296px');
            $(this).text('Rozwiń').removeClass('active');
        }
    });

    function initSlickIfMobile() {
        if ($(window).width() < 576) {
            $('.home-1').slick({
                slidesToShow: 1,
                arrows: true,
                dots: true
            });
        }
    }

    initSlickIfMobile();


    function isMobile() {
        return window.innerWidth < 768;
    }

    function toggleSidebarSection() {
        if (!isMobile()) return;

        $('h2.woocommerce-sidebar__heading').off('click').on('click', function () {
            $(this).next('div').slideToggle();
            $(this).toggleClass('active');
        });
    }

    toggleSidebarSection();

    $(window).on('resize', function () {
        toggleSidebarSection();
    });


});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".sf-category-tree .sf-toggle").forEach(function (toggle) {
        toggle.addEventListener("click", function (e) {
            const parentLi = toggle.closest("li");
            parentLi.classList.toggle("active");
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const desc = document.querySelector(".sf-cat-description");
    const toggleBtn = document.querySelector(".sf-toggle-description");
    if (desc && toggleBtn) {
        toggleBtn.addEventListener("click", function () {
            desc.classList.toggle("active");
            this.textContent = desc.classList.contains("active") ? "Rozwiń" : "Zwiń";
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const btnSearch = document.querySelector('.btn-search');
    const searchBar = document.querySelector('.search-bar');

    if (btnSearch && searchBar) {
        btnSearch.addEventListener('click', function () {
            searchBar.classList.toggle('active');
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {

    if (window.innerWidth < 1024) {
        const menuItems = document.querySelectorAll('.menu-item-has-children > a');

        menuItems.forEach(function (link) {

            if (!link.querySelector('.mega-indicator')) {
                const span = document.createElement('span');
                span.className = 'mega-indicator';
                span.setAttribute('aria-hidden', 'true');
                link.appendChild(span);
            }

            const indicator = link.querySelector('.mega-indicator');
            if (indicator) {
                indicator.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const parent = link.closest('.menu-item-has-children');
                    parent.classList.toggle('mega-toggle-on');
                });
            }
        });
    }

});

document.addEventListener('DOMContentLoaded', function () {
    const toggler = document.querySelector('.navbar-toggler');
    const headerBottom = document.querySelector('.header-main__bottom');

    if (toggler && headerBottom) {
        toggler.addEventListener('click', function () {
            headerBottom.classList.toggle('active');
        });
    }
});